// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1pUO1","author":"Table_author__ledaR","authorImage":"Table_authorImage__2U715","unreadRow":"Table_unreadRow__gtxbB"};